import { atom } from "recoil";

export const activeTabAtom = atom({
  key: "noticeModal",
  default: "Home",
});

export const myPetsAtom = atom<any[]>({
  key: "myPetsAtom",
  default: [],
});

export const missingPetsAtom = atom<any[]>({
  key: "missingPetsAtom",
  default: [],
});

export const locationAtom = atom({
  key: "location",
  default: {
    long: 126.9788,
    lat: 37.5666,
  },
});

export const myLocationAtom = atom({
  key: "myLocation",
  default: {
    long: 0,
    lat: 0,
  },
});

export const detectedDeviceCodesAtom = atom<string[]>({
  key: "detectedDeviceCodes",
  default: [],
});

export const intervalCountAtom = atom<number>({
  key: "intervalCount",
  default: 0,
});

export const appVersionAtom = atom<string>({
  key: "appVersion",
  default: "",
});

export const isAppPreReleaseVersionAtom = atom<boolean>({
  key: "isAppPreReleaseVersion",
  default: false,
});

export const scanTypeAtom = atom<string>({
  key: "scanType",
  default: "SCAN",
});
